export interface ScrollTarget {
  scrollTop: number;
  readonly scrollHeight: number;
}

export function scrollToLatest(target: ScrollTarget) {
  target.scrollTop = target.scrollHeight;
}

export function scheduleScrollToLatest(target: HTMLElement) {
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => scrollToLatest(target));
  });
}
